export const FOLLOW_NOTIFICATION = "FOLLOW";
export const PROFILE_COMMENT_NOTIFICATION = "PROFILE_COMMENT";
export const RESPONSE_COMMENT_NOTIFICATION = "RESPONSE_COMMENT";
export const POST_COMMENT_NOTIFICATION = "POST_COMMENT";
export const POST_LIKE_NOTIFICATION = "POST_LIKE";
export const GIFT_NOTIFICATION = "GIFT";
export const JOB_APPLICATION_RECEIVED_NOTIFICATION = "JOB_APPLICATION_RECEIVED";
export const CRUSH_RECEIVED_NOTIFICATION = "CRUSH";
